import {
  CTP_PGA_SEASON_4,
  CTP_PGA_AUSTRALIA_SEASON_4,
  LONGEST_DRIVE_PGA_AUSTRALIA_SEASON_4,
  LONGEST_DRIVE_PGA_SEASON_4,
  AGGREGATE_CTP_S4,
  SOCIAL_MEDIA_S4,
  LONGEST_DRIVE_MEN_S4,
  LONGEST_DRIVE_WOMEN_S4,
  CTP_S4,
  CTP_EPSON,
  LONGEST_DRIVE_EPSON,
  SOCIAL_MEDIA_EPSON,
  CTP_WORLD_SERIES_STAGE_2_3_S4,
  CTP_CHAMPIONSHIP_S4,
  LONGEST_DRIVE_WOMEN_CHAMPIONSHIP_S4,
} from "@/utils/constants";
import {
  getPrizeTable,
  getPurse,
  getTournamentType,
} from "@/utils/tournaments";
import CalculatePrize from "./CalculatePrize";
import PurseCard from "./PurseCard";
import FullPrizeList from "./FullPrizeList";

interface PurseSeason4Props {
  playersCount: number;
  tournamentName: string;
  tournamentId: string;
  inputVal: string;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PurseSeason4 = ({
  playersCount,
  tournamentName,
  tournamentId,
  inputVal,
  handleInputChange,
}: PurseSeason4Props) => {
  const type = getTournamentType(4, tournamentId, tournamentName);
  const isNextWorldSeries2or3 =
    type.isNextWorldSeries &&
    (tournamentName.toLowerCase().includes("stage 2") ||
      tournamentName.toLowerCase().includes("stage 3"));
  const purse = `$${getPurse(
    4,
    tournamentId,
    tournamentName,
    playersCount,
  ).toLocaleString("en-US")}`;

  const prizeList = getPrizeTable(
    4,
    tournamentId,
    tournamentName,
    playersCount,
  );

  if (type.isEpsonS4) {
    return (
      <div className="flex justify-center">
        <div className="w-full min-[1041px]:!max-w-[965px]">
          <ul className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full list-none mb-[50px]">
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{purse}</span>
              <span className="text-xl text-tm-c-gray-300">Purse</span>
            </li>
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{playersCount}</span>
              <span className="text-xl text-tm-c-gray-300">Players</span>
            </li>
          </ul>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 2xl:gap-[30px]">
            <CalculatePrize
              prizeList={prizeList}
              inputVal={inputVal}
              handleInputChange={handleInputChange}
            />
            <PurseCard title="Stroke play" prizeList={prizeList} />
            <PurseCard title={`CTP - All Par 3's`} prizeList={CTP_EPSON} />
            <PurseCard
              title={`Longest Drive`}
              prizeList={LONGEST_DRIVE_EPSON}
            />
            <PurseCard title={`Social Media`} prizeList={SOCIAL_MEDIA_EPSON} />
          </div>
          <FullPrizeList />
        </div>
      </div>
    );
  }

  if (type.isNextTourChampionship) {
    return (
      <div className="flex justify-center">
        <div className="w-full min-[1041px]:!max-w-[965px]">
          <ul className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full list-none mb-[50px]">
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{purse}</span>
              <span className="text-xl text-tm-c-gray-300">Purse</span>
            </li>
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{playersCount}</span>
              <span className="text-xl text-tm-c-gray-300">Players</span>
            </li>
          </ul>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 2xl:gap-[30px]">
            <CalculatePrize
              prizeList={prizeList}
              inputVal={inputVal}
              handleInputChange={handleInputChange}
            />
            <PurseCard title="Stroke play" prizeList={prizeList} />
            <PurseCard title={`CTP - All`} prizeList={CTP_CHAMPIONSHIP_S4} />
            <PurseCard title="Aggregate CTP" prizeList={CTP_CHAMPIONSHIP_S4} />
            <PurseCard
              title={`Longest Drive - Men\n`}
              prizeList={LONGEST_DRIVE_MEN_S4}
            />
            <PurseCard
              title={`Longest Drive - Women\n`}
              prizeList={LONGEST_DRIVE_WOMEN_CHAMPIONSHIP_S4}
            />
          </div>
          <FullPrizeList />
        </div>
      </div>
    );
  }

  if (type.isPGAAustraliaS4 || type.isPGACanadaS4) {
    return (
      <div className="flex justify-center">
        <div className="w-full min-[1041px]:!max-w-[965px]">
          <ul className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full list-none mb-[50px]">
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{purse}</span>
              <span className="text-xl text-tm-c-gray-300">Purse</span>
            </li>
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{playersCount}</span>
              <span className="text-xl text-tm-c-gray-300">Players</span>
            </li>
          </ul>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 2xl:gap-[30px]">
            <CalculatePrize
              prizeList={prizeList}
              inputVal={inputVal}
              handleInputChange={handleInputChange}
            />
            <PurseCard title="Stroke play" prizeList={prizeList} />
            <PurseCard
              title="CTP - All Par 3's"
              prizeList={CTP_PGA_AUSTRALIA_SEASON_4}
            />
            <PurseCard
              title="Longest Drive - Men/Women"
              prizeList={LONGEST_DRIVE_PGA_AUSTRALIA_SEASON_4}
            />
          </div>
          <FullPrizeList />
        </div>
      </div>
    );
  }

  if (type.isPGAAmericaS4) {
    return (
      <div className="flex justify-center">
        <div className="w-full min-[1041px]:!max-w-[965px]">
          <ul className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full list-none mb-[50px]">
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{purse}</span>
              <span className="text-xl text-tm-c-gray-300">Purse</span>
            </li>
            <li className="flex flex-col gap-2.5">
              <span className="text-4xl 2xl:text-6xl">{playersCount}</span>
              <span className="text-xl text-tm-c-gray-300">Players</span>
            </li>
          </ul>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 2xl:gap-[30px]">
            <CalculatePrize
              prizeList={prizeList}
              inputVal={inputVal}
              handleInputChange={handleInputChange}
            />
            <PurseCard title="Stroke play" prizeList={prizeList} />
            <PurseCard title="CTP - All Par 3's" prizeList={CTP_PGA_SEASON_4} />
            <PurseCard
              title="Longest Drive - Men/Women"
              prizeList={LONGEST_DRIVE_PGA_SEASON_4}
            />
          </div>
          <FullPrizeList />
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center">
      <div className="w-full min-[1041px]:!max-w-[965px]">
        <ul className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full list-none mb-[50px]">
          <li className="flex flex-col gap-2.5">
            <span className="text-4xl 2xl:text-6xl">{purse}</span>
            <span className="text-xl text-tm-c-gray-300">Purse</span>
          </li>
          <li className="flex flex-col gap-2.5">
            <span className="text-4xl 2xl:text-6xl">{playersCount}</span>
            <span className="text-xl text-tm-c-gray-300">Players</span>
          </li>
        </ul>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-5 2xl:gap-[30px]">
          <CalculatePrize
            prizeList={prizeList}
            inputVal={inputVal}
            handleInputChange={handleInputChange}
          />
          <PurseCard
            title="Stroke play"
            prizeList={Array.from({ length: 5 }, (_, i) => prizeList?.[i] ?? 0)}
          />
          <PurseCard title="Aggregate CTP" prizeList={AGGREGATE_CTP_S4} />
          <PurseCard
            title="CTP - All Par 3's"
            prizeList={
              isNextWorldSeries2or3 ? CTP_WORLD_SERIES_STAGE_2_3_S4 : CTP_S4
            }
          />
          {!isNextWorldSeries2or3 && (
            <PurseCard title="Social Media" prizeList={SOCIAL_MEDIA_S4} />
          )}
          <PurseCard
            title="Longest Drive - Men"
            prizeList={LONGEST_DRIVE_MEN_S4}
          />
          <PurseCard
            title="Longest Drive - Women"
            prizeList={LONGEST_DRIVE_WOMEN_S4}
          />
        </div>
        <FullPrizeList />
      </div>
    </div>
  );
};

export default PurseSeason4;
